import { FilterPipe } from './../pipes/filter.pipe';
import { MediatypeIconPipe } from './../pipes/mediatypeIcon.pipe';
import { NumberMaxCharsPipe } from './../pipes/numberMaxChars.pipe';
import { TrendPipe } from './../pipes/trend.pipe';
import { ObjectAsArrayPipe } from './../pipes/objectAsArray.pipe';
import { DatePipe } from '@angular/common';
import { TitleCasePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IterablePipe } from '../pipes/iterable.pipe';
import { ColorsPipe } from '../pipes/colors.pipe';
import { HotkeyPipe } from '../pipes/hotkey.pipe';
import { SecondsPipe } from '../pipes/seconds.pipe';
import { ClipIconPipe } from '../pipes/clipIcon.pipe';
import { ThumbnailPipe } from '../pipes/thumbnail.pipe';
import { ValueToLabelPipe } from '../pipes/value-to-label.pipe';
import { WidgetIconPipe } from '../pipes/widgetIcon.pipe';
import { StatusIconPipe } from '../pipes/statusIcon.pipe';
import { StringPipe } from '../pipes/string.pipe';
import { PercentagePipe } from '../pipes/percentage.pipe';
import { TruncatePipe } from '../pipes/truncate.pipe';
import { ClipTitlePipe } from '../pipes/clipTitle.pipe';
import { ToCodePipe } from '../pipes/toCode.pipe';
import { FileSizePipe } from '../pipes/fileSize.pipe';
import { FilterSetUrlPipe } from '../pipes/filterSetUrl.pipe';
import { OrderBy } from '../pipes/orderBy.pipe';
import { CommaSeparatedProperty } from '../pipes/commaSeparatedProperty.pipe';
import { DeviceInfoPipe } from '../pipes/deviceInfo.pipe';
import { NumberWithLetterPipe } from '../pipes/numberWithLetter.pipe';
import { FontsPipe } from '../pipes/fonts.pipe';
import { BbDatePipe } from 'app/pipes/bb-date.pipe';
import { BbStreamStatusIcon } from '../pipes/bbStreamStatusIcon.pipe';
import { SharedPublicationIdToName } from '../pipes/sharedPublicationIdToName.pipe';
import { TimeRemainingPipe } from '../pipes/timeRemaining.pipe';
import { NewLinePipe } from '../pipes/newLine.pipe';
import { EntityLabelPipe } from '../pipes/entity-label.pipe';


const pipes = [
	IterablePipe,
	FilterPipe,
	TrendPipe,
	NumberMaxCharsPipe,
	NumberWithLetterPipe,
	ObjectAsArrayPipe,
	ThumbnailPipe,
	ValueToLabelPipe,
	WidgetIconPipe,
	StatusIconPipe,
	StringPipe,
	PercentagePipe,
	TruncatePipe,
	ColorsPipe,
	HotkeyPipe,
	SecondsPipe,
	ClipTitlePipe,
	TimeRemainingPipe,
	ToCodePipe,
	FileSizePipe,
	OrderBy,
	FilterSetUrlPipe,
	ClipIconPipe,
	CommaSeparatedProperty,
	MediatypeIconPipe,
	DeviceInfoPipe,
	EntityLabelPipe,
	FontsPipe,
	NewLinePipe,
	BbDatePipe,
	BbStreamStatusIcon,
	SharedPublicationIdToName
];

@NgModule({
	declarations: pipes,
	imports: [CommonModule],
	exports: pipes,
	providers: [...pipes, DatePipe, TitleCasePipe]
})

export class PipesModule {}
